import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { MatchsCreditBalanceStat } from '../matchs-credit-balance-stat.model';

@JsonObject('MatchsCreditBalanceResultsResponse')
export class MatchsCreditBalanceResultsResponse extends ApiResultsResponse<MatchsCreditBalanceStat> {

  @JsonProperty('results', [MatchsCreditBalanceStat])
  override results: MatchsCreditBalanceStat[] = [];
}
